import React, { useState, useEffect, useRef } from 'react';
import styles from './styles/winampp.style.module.css';
import { selectPlaylistVisible } from './appSlice';
import Player from './player/Player';
import { Provider, useSelector } from 'react-redux';
import Playlist from './playlist/Playlist';
import store from './store';
import { Logs } from '../todo/models/logs';
import firebase from "../../firebase";
import moment from 'moment';
import { getDatabase,onValue, ref, orderByChild, equalTo, get, set, child, update,query,push } from "firebase/database";

function Main() {
  const playlistVisible = useSelector(selectPlaylistVisible);

  const [x, setX] = useState(0);
  const [y, setY] = useState(0);
  const [originalPosition, setOriginalPosition] = useState({ x: 0, y: 0 });
  const [originalMousePosition, setOriginalMousePosition] = useState({ x: 0, y: 0 });
  const [dragged, setDragged] = useState(false);
  //const [logs, setLogs] = useState<Array<Logs>>([]);
  const [count,setCount] = useState(0);
  const countRef = useRef(0);
  const db = getDatabase();

  useEffect(() => {

    get(ref(db,'/logs')).then((snapshot) => {
      var newCount = 0;
      snapshot.forEach(child => {
        newCount = newCount + 1;
      });
      setCount(newCount);
      //setCountFunc(newCount);
    });
  },[]);

  countRef.current = count;

  useEffect(() => {
    var curtime = moment().format("DD/MM/YYYY HH:mm:ss");
      //var refdb_ref:string;
      var refdb = push(ref(db,'/logs'));
      //refdb_ref = refdb.toString().slice(-20);
      
      fetch('https://ipapi.co/json')
        .then(res => res.json())
        .then((dataipres) => {
          //let updateData = ref(db,"logs/"+refdb);
          set(refdb,{
            id:countRef.current+1,
            status:'1',
            message:'User Access Winamp Page',
            agent:String(navigator.userAgent),
            ip: String(dataipres.ip),
            location:String(dataipres.country_name+'#'+dataipres.region),
            user_id:String(localStorage.getItem('user_id')),
            time:String(curtime)
          });
      });
  },[]);  

  const handleMouseMove = (event: React.MouseEvent) => {
    if (!dragged) {
      return;
    }
    event.preventDefault();

    const mouseEvent = event.nativeEvent;
    if (!(mouseEvent instanceof MouseEvent)) {
      throw new Error('Is not mouse event');
    }

    const moveX = mouseEvent.x - originalMousePosition.x;
    const moveY = mouseEvent.y - originalMousePosition.y;

    setX(originalPosition.x + moveX);
    setY(originalPosition.y + moveY);
  };

  const handleMouseUp = (event: React.MouseEvent) => {
    if (!dragged) {
      return;
    }
    event.preventDefault();

    setDragged(false);
  };

  const handleMouseDown = (event: React.MouseEvent) => {
    event.preventDefault();
    const mouseEvent = event.nativeEvent;
    if (!(mouseEvent instanceof MouseEvent)) {
      throw new Error('Is not mouse event');
    }

    setOriginalPosition({ x, y });
    setDragged(true);
    setOriginalMousePosition({ x: mouseEvent.x, y: mouseEvent.y });
  };

  return (
    <div className={styles.app} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp}>
      <div
        className={styles.player}
        style={{ left: `calc(100vw / 2 - 548px / 2 + ${x}px)`, top: `calc(100px + ${y}px)`, marginTop: `30vh` }}
      >
        <Player />
        <div className={styles.dragArea} onMouseDown={handleMouseDown} />
        {playlistVisible && <Playlist />}
      </div>
    </div>
  );
}

function Winampp() {
  return (
    <Provider store={store}>
      <meta name="viewport" content="width=device-width, initial-scale=0.7" />
      <Main />
    </Provider>
  );
}

export default Winampp;
